import { inject, observer } from 'mobx-react';
import { IImpersonationContext } from '../../../../extViewmodels';
import {
	FullScreenModalViewModelKey,
	IFullscreenModalComponentProps,
	IUserSessionComponentProps,
	UserSessionViewModelKey,
} from '../../../../models/AppState';
import {
	AppDrawer,
	AppDrawerToolbar,
	AppDrawerToolbarButtonAiAssistant,
	StickyAppDrawerContent,
} from '../../../components-v2/Drawer/AppDrawer';
import { DefaultUniversalAssistantChat } from '../../templates/AssistantChat';
import { TagsDataContextProvider } from './TagsContexts/TagsDataContext';
import { TagsSearchContextProvider } from './TagsContexts/TagsSearchContext';
import { TagsMain } from './TagsMain';

export const TagsContainer: React.FC<
	IFullscreenModalComponentProps &
		IUserSessionComponentProps & {
			isAdminContext?: boolean;
			impersonationContext?: IImpersonationContext;
		}
> = inject(
	FullScreenModalViewModelKey,
	UserSessionViewModelKey
)(
	observer(props => {
		const { isAdminContext, impersonationContext } = props;

		return (
			<>
				<TagsSearchContextProvider>
					<TagsDataContextProvider impersonationContext={impersonationContext}>
						<TagsMain isAdminContext={isAdminContext} impersonationContext={impersonationContext} />
					</TagsDataContextProvider>
				</TagsSearchContextProvider>
				<AppDrawer>
					<StickyAppDrawerContent value='ai-assistant'>
						<DefaultUniversalAssistantChat />
					</StickyAppDrawerContent>
					<AppDrawerToolbar>
						<AppDrawerToolbarButtonAiAssistant value='ai-assistant' />
					</AppDrawerToolbar>
				</AppDrawer>
			</>
		);
	})
);
